import { render, staticRenderFns } from "./VideoAdd.vue?vue&type=template&id=1a59c474"
import script from "./VideoAdd.vue?vue&type=script&lang=js"
export * from "./VideoAdd.vue?vue&type=script&lang=js"
import style0 from "./VideoAdd.vue?vue&type=style&index=0&id=1a59c474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports